module.exports = __webpack_public_path__ + "img/618.1af9eb7b.png";